import { makeEntityScaffold } from '@classpass/saga-tools';
import urls from 'constants/urls';
import { MESSAGE_USER_ENTITY_TYPES } from 'constants/logic';
import { transformKeysToSnakeCase, transformKeysToCamelCase } from 'helpers/core';

const get = (httpClient, { venueId, reservationId }) => {
  const url = urls.user.getConversationStatus(venueId, reservationId);

  return httpClient.get(url).then(res => transformKeysToCamelCase(res.data));
};

const post = (httpClient, { venueId, reservationId }) => {
  const url = urls.user.initiateConversation(venueId);
  const payload = transformKeysToSnakeCase({
    reservationId,
  });

  return httpClient.post(url, payload).then(res => transformKeysToCamelCase(res.data));
};

const handler = ({ httpClient }, { venueId, reservationId = null, type = MESSAGE_USER_ENTITY_TYPES.GET }) => {
  if (!reservationId) {
    return;
  }

  if (type === MESSAGE_USER_ENTITY_TYPES.POST) {
    return post(httpClient, { venueId, reservationId });
  }

  return get(httpClient, { venueId, reservationId });
};

export default makeEntityScaffold('SAGA.API.MESSAGE_USER', handler, {
  defaultKey: (_, { reservationId }) => `${reservationId}`,
});
